<template>
  <div id="contacts">
    <div id="container" v-if="contact.loaded">
      <div class="box shadow">
        <topdata v-bind:data="topData"></topdata>
      </div>

      <div class="column column-33 no-padding-left">
        <transition name="fade">
          <div class="box shadow" v-if="contact.data.description">
            <h2>{{ $t('extra-info' )}}</h2>
            <p>{{ contact.data.description }}</p>
          </div>
        </transition>

        <div class="box shadow">
          <h2>{{ $t('data') }}</h2>

          <table class="contact-data">
            <tr>
              <td>{{ $t('address') }}</td>
              <td>
                <a :href="$parent.getDirectionsUrl(contact.data.address)" target="_blank">
                  {{ $t('address-firstline', {
                        street: contact.data.address.street,
                        number: contact.data.address.number,
                        zipcode: contact.data.address.zipcode,
                        city: contact.data.address.city,
                        state: contact.data.address.state,
                        country: contact.data.address.country,
                  }) }}<br/>
                  {{ $t('address-secondline', {
                        street: contact.data.address.street,
                        number: contact.data.address.number,
                        zipcode: contact.data.address.zipcode,
                        city: contact.data.address.city,
                        state: contact.data.address.state,
                        country: contact.data.address.country,
                  }) }}<br/>
                  {{ $t('address-thirdline', {
                        street: contact.data.address.street,
                        number: contact.data.address.number,
                        zipcode: contact.data.address.zipcode,
                        city: contact.data.address.city,
                        state: contact.data.address.state,
                        country: contact.data.address.country,
                  }) }}
                </a>
              </td>
            </tr>

            <tr v-if="contact.data.emails.length > 0">
              <td>{{ $tc('email-address', contact.data.emails.length) }}</td>
              <td>
                <div v-for="email in contact.data.emails"><a :href="`mailto:${email}`" target="_blank">{{ email }}</a><br/></div>
              </td>
            </tr>

            <tr v-if="contact.data.phones.length > 0">
              <td>{{ $tc('phone-number', contact.data.phones.length) }}</td>
              <td>
                <div v-for="phone in contact.data.phones"><a :href="`tel:${phone}`">{{ phone }}</a><br/></div>
              </td>
            </tr>

            <tr v-if="contact.data.coc">
              <td>{{ $t('coc-number') }}</td>
              <td>{{ contact.data.coc }}</td>
            </tr>

            <tr v-if="contact.data.vat">
              <td>{{ $t('vat-number') }}</td>
              <td>{{ contact.data.vat }}</td>
            </tr>

            <tr v-if="contact.data.website">
              <td>{{ $t('website') }}</td>
              <td>{{ contact.data.website }}</td>
            </tr>
          </table>
        </div>

        <div class="box shadow">
          <h2>Interne notities</h2>

          <transition name="fade">
            <div class="internal-messages" v-show="contact.loaded">
              <div class="messages-wrapper">
                <div class="no-messages"
                     v-show="!hasMessages(contact.data)">
                  {{ $t('no-internal-messages') }}
                </div>
              </div>

              <div class="new-message shadow">
                <form v-on:submit.prevent="sendNewInternalMessage">
                  <div class="attachment">
                    <label for="new-message-file"><i class="fal fa-paperclip clickable"></i></label>
                    <input id="new-message-file"
                           type="file"
                           multiple
                           ref="internalMessageFile"
                           v-on:change="handleFileUpload()">
                  </div><!--
                  --><div class="message-text">
                  <input type="text"
                         v-model="newInternalMessage.message"
                         placeholder="Typ een bericht...">
                </div><!--
                  --><div class="send-button">
                  <button class="clickable">Verzenden</button>
                </div>
                </form>
              </div>

              <message v-for="(message, index) in contact.data.internal_messages"
                       :message="message"
                       :key="index"></message>

              <!--
              <transition name="fade">
                <div class="uploadedFiles" v-show="newInternalMessage.files.length > 0">
                  <h3>{{ $t('added-files') }}</h3>
                  <div class="uploadedFile"
                       v-for="(file, index) in newInternalMessage.files"
                       :key="index">
                    <i class="fal fa-file"></i> {{ file.name }}<br/><br/>
                  </div>
                </div>
              </transition>
              -->
            </div>
          </transition>

          <div class="loader" v-if="!contact.loaded"></div>
        </div>
      </div><!--

      --><div class="column column-66 no-padding-right">
      <div class="box shadow">
        <h2>{{ $tc('contact-companies', contact.data.companies.length) }}</h2>

        <div class="no-contacts" v-if="contact.data.companies.length === 0">
          {{ $t('no-companies') }}
        </div>

        <div class="multi-contacts" v-if="contact.data.companies.length > 0">
          <transition-group name="fade">
            <div class="inline-block  contact-summary-wrapper"
                 v-for="(company, index) in contact.data.companies"
                 v-show="index < 4 || showExtraContacts"
                 style="width: 50%;"
                 :key="index">
              <router-link class="contact-summary clickable shadow"
                   tag="div"
                   :to="`/companies/${company._id}`">
                <div class="contact-thumb"><img src="https://placehold.it/100x100" class="round"/></div>

                <div class="contact-info">
                  <div class="contact-name"><h4 class="accent-color">{{ company.name }}</h4></div>
                  <div class="contact-phone" v-if="company.address">{{ company.address.city }}</div>
                </div>
              </router-link>
            </div>
          </transition-group>

          <div class="show-extra center" v-if="contact.data.companies.length > 4 && !showExtraContacts">
            <button class="button button-default" @click="showExtraContacts = true">Alles weergeven</button>
          </div>
        </div>

      </div>

      <div class="box shadow">
        <h2>{{ $t('communication') }}</h2>

        <transition name="fade">
          <div class="content" v-show="contact.loaded">
            <message v-for="(message, index) in contact.data.communication"
                     :message="message"
                     :key="index"></message>

            <div class="no-messages"
                 v-if="!hasCommunication(contact.data)">
              {{ $t('no-messages') }}
            </div>
          </div>
        </transition>


      </div>
    </div>

    </div>

    <div class="loader" v-else></div>

  </div>
</template>

<script>
import { Contacts } from '@/services/api/ApiRoutes';

export default {
  name: 'SingleContact',

  data() {
    // Set page title
    this.$parent.title.heading = 'Contact';
    this.$parent.title.subheading = '';

    return {
      topData: [],
      contact: {
        error: null,
        data: [],
        loaded: false,
      },
      newInternalMessage: {
        message: '',
        files: [],
      },
      showExtraContacts: false,
    };
  },

  mounted() {
    this.getContact(this.$route.params.id);
  },

  methods: {
    getContact(id) {
      Contacts.getOne(id).then((contact) => {
        this.contact.error = null;
        this.contact.data = contact;

        this.$parent.title.subheading = contact.name;
        this.updateTopData(contact);

        this.contact.loaded = true;
      }).catch((error) => {
        this.contact.error = error;
        this.contact.loaded = true;
      });
    },

    updateTopData(contact) {
      this.topData = [
        {
          title: this.$t('contact'),
          value: contact.fullName,
          icon: 'fa-user',
          link: `/contacts/${contact._id}`,
        },
        {
          title: this.$t('contact-moments'),
          value: contact.communication.length,
          icon: 'fa-comments',
          link: `/contacts/${contact._id}`,
        },
        {
          title: this.$t('last-contact'),
          value: this.$moment(contact.created_at).fromNow(),
          icon: 'fa-user',
          link: `/contacts/${contact._id}`,
        },
        {
          title: this.$t('created-at'),
          value: this.$moment(contact.created_at).fromNow(),
          icon: 'fa-calendar',
          link: `/contacts/${contact._id}`,
        },
      ];
    },

    hasMessages(contact) {
      try {
        return contact.internal_messages.length > 0;
      } catch (e) {
        return false;
      }
    },

    hasCommunication(contact) {
      try {
        return contact.communication.length > 0;
      } catch (e) {
        return false;
      }
    },

    sendNewInternalMessage() {
    },

    handleFileUpload() {
      this.newInternalMessage.files = this.$refs.internalMessageFile.files;
    },
  },
};
</script>

<style scoped>
  table tr td:first-child {
    font-weight: 500;
  }

  td {
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/pages/contacts/SingleContact.vue